
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section className="bg-gradient-to-r from-ai-indigo to-ai-purple py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
          <span className="block">Ready to dive deeper?</span>
          <span className="block">Subscribe to our premium content.</span>
        </h2>
        <p className="mt-4 text-lg leading-6 text-indigo-100">
          Get unlimited access to exclusive articles, analyses, and expert insights.
        </p>
        <div className="mt-8 flex justify-center">
          <div className="inline-flex rounded-md shadow">
            <Link to="/pricing?scrollTo=pricing-plans">
              <Button className="bg-white text-ai-indigo hover:bg-gray-50">
                View Pricing
              </Button>
            </Link>
          </div>
          <div className="ml-3 inline-flex">
            <Link to="/articles">
              <Button className="bg-white text-ai-indigo hover:bg-gray-50">
                Explore Content
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
